import gql from 'graphql-tag';

import { FRAGMENT_CONTENT_VALIDATION, FRAGMENT_IMAGE_OVERLAY_TEXT } from 'src/graphql/schema';

export const VARIATION_EXPORT_INFO_FRAGMENT = gql`
  fragment VariationExportInfo on VariationExportInfo {
    dataSource
    accountName
    user {
      id
      name
      email
    }
    createdAt
  }
`;

export const VARIATION_FRAGMENT = gql`
  fragment Variation on Variation {
    id
    projectAiSuggestionRequestId
    projectAiRecomposeRequestId
    originalVariationId
    significantImproveOrigin
    assetType
    groupIdx
    mixtureSubAssetType
    generationTool
    source
    suggestionMode
    recomposeMode
    status
    copyText
    copyTextMarkup
    score
    isEnterpriseScoreUsed
    lastUpdateTime
    createdAt
    ageScoreHistogram
    genderScoreHistogram
    scoringMethod {
      id
      type
      name
    }
    secondaryScoringMethod {
      id
      type
      name
    }
    contentSafety {
      ...ContentValidation
    }
    engagementScoreSupportSize
    landingPageAsset {
      id
      significantImproveScoreThreshold
    }
    generationGuidance {
      keywords
      campaignKeywords
      features
      benefits
      pains
      avatar
      tov
    }
    isScoreLocked
    performancePredictionsScoreLocked
    isEdited
    isRecompose
    classifiedGenerationTool
    benchmarkConfig {
      userCreated
      account {
        id
        name
        channel
      }
      assetType
      comparisonSet {
        name
        description
        userGoal
        examples
      }
    }
    chainId
    blockId
    multiPromptStepIndex
    multiPromptStepName
    multiPromptTool
    customMultiPromptId
    chainFields
    rating
    csvChainId
    imageBlob
    imageMeta
    imagePath
    imageStyleId
    overlayText {
      ...ImageOverlayText
    }
    language
    overrideLanguage
    customFormatIds
    exportInfo {
      ...VariationExportInfo
    }
    complianceStatus
    complianceProgressPercentage
  }
  ${FRAGMENT_CONTENT_VALIDATION}
  ${FRAGMENT_IMAGE_OVERLAY_TEXT}
  ${VARIATION_EXPORT_INFO_FRAGMENT}
`;

export const VARIATION_RATING_FRAGMENT = gql`
  fragment VariationRating on VariationRating {
    id
    rating
    positiveRatingsCount
    negativeRatingsCount
  }
`;

export const VARIATION_RATINGS_FRAGMENT = gql`
  fragment VariationRatings on VariationRatings {
    ...VariationRating
  }
  ${VARIATION_RATING_FRAGMENT}
`;
